import { showToast } from "src/app/methods/showToast";

// Chrome/Firefox: DOMException name "QuotaExceededError" (code 22 legacy Chrome, 1014 legacy Firefox). Safari matches the same name.
const isQuotaExceededError = (error: unknown): boolean =>
  error instanceof DOMException &&
  (error.name === "QuotaExceededError" ||
    error.code === 22 ||
    error.code === 1014);

export const saveToLocalStorage = <T>(key: string, value: T) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.warn(`Error setting localStorage key “${key}”:`, error);
    if (isQuotaExceededError(error)) {
      showToast(
        "error",
        "Storage limit reached",
        "Your browser's local storage is full, so some settings couldn't be saved.",
      );
    }
  }
};

export const getFromLocalStorage = <T>(key: string): T | null => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    console.warn(`Error getting localStorage key “${key}”:`, error);
    return null;
  }
};
